import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { AdministradoresApi } from '@/services/api-routes'
import { emptyPage } from '@/types/api'
import type { AdministradorResumo, ListarAdministradoresQuery } from '@/types/administrador'
import { administradoresKeys } from '@/http/queryKeys'
import { defaultOptions } from '@/http/default-query-options'

export const useAdministradoresQuery = (query: ListarAdministradoresQuery, enabled = true) =>
  useQuery({
    queryKey: administradoresKeys.list(query),
    queryFn: async ({ signal }) =>
      (await AdministradoresApi.listar(query, signal)) ?? emptyPage<AdministradorResumo>(),
    placeholderData: keepPreviousData,
    enabled,
    ...defaultOptions,
  })
